import React from "react";
export default function NotFound() {
  return (
    <div>
      <h1 style={{ color: "red" }}>404</h1>
      <h2 >Page not found.</h2>
    </div>
  );
}
